export default __webpack_public_path__ + "static/media/60.ae792411.jpg";